import React, { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "./firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

function Help() {
    const [user] = useAuthState(auth);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("");

        if (!message.trim()) {
            setStatus("⚠ Message cannot be empty.");
            return;
        }

        try {
            await addDoc(collection(db, "feedback"), {
                uid: user.uid,
                message: message.trim(),
                email: user.email,
                timestamp: serverTimestamp(),
            });
            setStatus("✅ Feedback submitted. Thank you!");
            setMessage("");
        } catch (err) {
            setStatus("❌ Failed to send feedback.");
            console.error(err);
        }
    };

    const faqs = [
        {
            question: "How do I buy credits?",
            answer: "Go to the Pricing page and choose the credit plan that suits your needs.",
        },
        {
            question: "What types of emails does the scrubber detect?",
            answer: "Our scrubber detects invalid, duplicate, disposable, and risky emails.",
        },
        {
            question: "Do my credits ever expire?",
            answer: "No, your credits never expire. Use them whenever you need.",
        },
        {
            question: "How do I upload my email list?",
            answer: "Go to your dashboard, click 'Upload List', and select a CSV file from your device.",
        },
        {
            question: "Is my data stored securely?",
            answer: "Yes, all data is encrypted and securely hosted on servers in Europe (GDPR compliant).",
        },
        {
            question: "Can I log in with Google?",
            answer: "Absolutely. You can sign up or log in using your Google account with one click.",
        },
        {
            question: "What happens after I scrub my email list?",
            answer: "You’ll be able to download a cleaned version of your list with invalid addresses removed.",
        },
        {
            question: "How accurate is the email scrubbing?",
            answer: "Our AI-powered system is highly accurate and continuously improving with real-world feedback.",
        },
        {
            question: "Can I see my credit usage history?",
            answer: "Yes, your dashboard provides full logs of credit usage, uploads, and downloads.",
        },
        {
            question: "Is there a free trial or demo?",
            answer: "We currently do not offer a free trial, but you can start with a small credit pack to test the service.",
        }
    ];

    return (
        <div className="help-container">
            <h2>❓ Help & Support</h2>

            <section className="faq-section">
                <h3>📘 Frequently Asked Questions</h3>
                {faqs.map((faq, idx) => (
                    <div key={idx} className="faq-item">
                        <h3><strong>Q:</strong> {faq.question}</h3>
                        <p><strong>A:</strong> {faq.answer}</p>
                    </div>
                ))}
            </section>

            {user ? (
                <section className="feedback-section">
                    <h3>✉️ Send Feedback</h3>
                    <form onSubmit={handleSubmit} className="feedback-form">
            <textarea
                className="feedback-textarea"
                placeholder="Your feedback..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={4}

            />
                        <button type="submit">Submit</button>
                    </form>
                    {status && <p className="feedback-status">{status}</p>}
                </section>
            ) : (
                <p style={{ marginTop: "30px" }}>🔐 Please log in to send feedback.</p>
            )}
        </div>
    );
}

export default Help;